import type { QueryParamsDto } from "@mimber/schema"

export const donationsKeys = {
  findAll: (params?: QueryParamsDto) =>
    params
      ? (["donations", "findAll", params] as const)
      : (["donations", "findAll"] as const),
  findOne: (uuid: string) => ["donations", "findOne", uuid] as const,
  findDonors: (params?: QueryParamsDto) =>
    params
      ? (["donations", "findDonors", params] as const)
      : (["donations", "findDonors"] as const),
  findReceipt: (donationUuid: string) =>
    ["donations", "findReceipt", donationUuid] as const,
  findStatements: (year?: number) =>
    typeof year === "number"
      ? (["donations", "findStatements", year] as const)
      : (["donations", "findStatements"] as const),
  findStatement: (donationUuid: string) =>
    ["donations", "findStatement", donationUuid] as const,
  findPages: (params?: QueryParamsDto) =>
    params
      ? (["donations", "findPages", params] as const)
      : (["donations", "findPages"] as const),
  findPage: (pageUuid: string) => ["donations", "findPage", pageUuid] as const,
} as const
